/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAnalyticsDashboardCategoriesResponse } from '../../models/get-analytics-dashboard-categories-response';

export interface GetAnalyticsDashboardCategories$Params {
}

export function getAnalyticsDashboardCategories(http: HttpClient, rootUrl: string, params?: GetAnalyticsDashboardCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAnalyticsDashboardCategoriesResponse>> {
  const rb = new RequestBuilder(rootUrl, getAnalyticsDashboardCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAnalyticsDashboardCategoriesResponse>;
    })
  );
}

getAnalyticsDashboardCategories.PATH = '/api/user/analytics/dashboard-categories';
